<template>
    <form @submit.prevent="submit">
        <modal width="small">
            <modal-header>
                Anfrage ablehnen
            </modal-header>
            <modal-content>
                <form-input id="rejected_subject" label="Betreff" v-model="form.rejected_subject"
                            :error="form.errors.rejected_subject"/>
                <form-html id="rejected_comment" label="Ablehnungs Grund" v-model="form.rejected_comment"
                           :error="form.errors.rejected_comment" height="300px"/>
            </modal-content>
            <modal-actions @closeDialog="this.$emit('closeDialog')">
                <form-button type="submit" color="error" :disabled="form.processing" :class="{'btn--processing': form.processing}">Anfrage ablehnen</form-button>
            </modal-actions>
        </modal>
    </form>
</template>

<script>
import Modal from '@partfactory/Shared/Modal/Modal';
import ModalActions from '@partfactory/Shared/Modal/ModalActions';
import FormButton from '@partfactory/Shared/Form/FormButton';
import ModalHeader from '@partfactory/Shared/Modal/ModalHeader';
import ModalContent from '@partfactory/Shared/Modal/ModalContent';
import {useForm} from '@inertiajs/vue3';
import FormInput from '@partfactory/Shared/Form/FormInput';
import FormHtml from '@partfactory/Shared/Form/FormHtml';

export default {
    name: 'ClientQuoteReject',
    components: {FormHtml, FormInput, ModalContent, ModalHeader, FormButton, ModalActions, Modal},
    props: {
        askForQuote: Object,
        reject: String,
    },
    emit: ['closeDialog'],
    data() {
        let subject = '', comment = '', translated = '';

        if (this.askForQuote.client_user.language === 2) {
            this.$language.current = 'en';
        }

        if (this.reject === 'quote') {
            translated = this.$gettext('Wichtige Information zu Ihrer Zeichnung %{pfnumber}');
            subject = this.$gettextInterpolate(translated, {pfnumber: this.askForQuote.pfnumber});

            translated = this.$gettext('<h1>Guten Tag %{name},</h1>' +
                '<p>vielen Dank für Anfrage %{pfnumber} (%{project_name}). Unsere kostenlose Überprüfung Ihrer Zeichnung hat zu folgendem Ergebnis geführt:</p>' +
                '<ol><li>Bemaßung XY fehlt</li>' +
                '<li>...</li></ol>' +
                '<p>Mit den aufgeführten Fehlern können wir Ihre Anfrage leider nicht bearbeiten. Daher bitten wir Sie, eine neue Anfrage mit einer korrigierten Zeichnung hochzuladen. Vielen Dank!</p>' +
                '<p>Hinweise zur Erstellung einer technisch eindeutigen Zeichnung finden Sie hier: <a href="%{technicalsketch}">technische Zeichnung erstellen</a></p>' +
                '<p>Beste Grüße</p><p>%{admin}, Service Operator PART FACTORY</p>');

            comment = this.$gettextInterpolate(translated, {
                name: this.askForQuote.client_user.name,
                pfnumber: this.askForQuote.pfnumber,
                project_name: this.askForQuote.project_name,
                technicalsketch: this.askForQuote.client_user.language === 2 ? this.$page.props.urls.technicalsketch_en : this.$page.props.urls.technicalsketch_de,
                admin: this.$page.props.user.name,
            });
        }

        if (this.reject === 'offer') {
            translated = this.$gettext('Leider können wir Ihre Anfrage %{pfnumber} derzeit nicht bearbeiten');
            subject = this.$gettextInterpolate(translated, {pfnumber: this.askForQuote.pfnumber});

            translated = this.$gettext('<h1>Guten Tag %{name},</h1>' +
                '<p>vielen Dank für die Anfrage bei der PART FACTORY.</p>' +
                '<p>Wir legen sehr viel Wert auf Qualität und Liefertreue. Leider haben wir für Ihre Anfrage zurzeit keinen passenden Produzenten gefunden und müssen sie daher leider ablehnen.</p>' +
                '<p>Wir erweitern unser Produzentennetzwerk kontinuierlich, so dass wir für Ihre nächste Anfrage bestimmt den passenden Partner finden können.</p>' +
                '<p>Beste Grüße</p><p>Sachbearbeiter, Service Operator PART FACTORY</p>');

            comment = this.$gettextInterpolate(translated, {
                name: this.askForQuote.client_user.name,
            });
        }
        this.$language.current = 'de';

        const form = useForm({
            rejected_subject: subject,
            rejected_comment: comment,
        });
        return {form};
    },
    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                }))
                .post(this.$$route('ask-for-quote.client-quote.reject', {'askForQuote': this.askForQuote.id}), {
                    onSuccess: () => this.$emit('closeDialog'),
                });
        }
    }
};
</script>
